import React, { Component, ErrorInfo, ReactNode } from "react"

type ErrorBoundaryProps = React.PropsWithChildren<{
    sendToRollbar?: boolean
}>

class ErrorBoundaryInline extends Component<ErrorBoundaryProps> {
    static defaultProps: ErrorBoundaryProps = {
        sendToRollbar: true,
    }

    state = {
        error: null,
    }

    static getDerivedStateFromError(error: Error) {
        return { error }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentDidCatch(error: Error, _errorInfo: ErrorInfo): void {
        if (window?.rollbar && this.props.sendToRollbar) window.rollbar.error(error)
    }

    render(): ReactNode {
        if (this.state.error) {
            return <span>Error</span>
        }
        return this.props.children
    }
}

export default ErrorBoundaryInline
